export default {
	lockReconnect:false,
	connected:false,
	ws: {},
	setWs: function(newWs){
		this.ws = newWs
	},
	compWsUrl(serverPre){
      let ws = JSON.parse(localStorage.getItem("ws"));
	  if(ws){
		  let wssed = serverPre.indexOf("https://") > -1;
		  wssed = wssed || window.location.protocol == "https:";
		  let websocketUrl = wssed ? "wss://" : "ws://";
		  websocketUrl += ws.ws_host;
		  websocketUrl += wssed
			? (ws.web_port && !(ws.web_port == 80 || ws.web_port == 443)
				? ":" + ws.web_port
				: "") + "/wss/"
			: ":" + ws.ws_port;
		  localStorage.setItem("ws_url", websocketUrl);
	  }
	},
	staticsMsgUnread(){// δ����Ϣ����
		var num = 0;
		var number = 0;
		var arr = localStorage.getItem("unread")?JSON.parse(localStorage.getItem("unread")):[];
		if(arr.length > 0){
			arr.forEach(element => {
				num += element.unreadNumber;
			});
		}
		var array = localStorage.getItem("groupUnread")?JSON.parse(localStorage.getItem("groupUnread")):[];
		if(array.length > 0){
			array.forEach(element => {
				number += element.unreadNumber;
			});
		}
		localStorage.setItem("countUnread", num + number);
		return num + number;
	},
	recordUnreadChat(data){
		if (data.tag == "one") {// ��¼����δ����Ϣ��
			var unreads = localStorage.getItem("unread")?JSON.parse(localStorage.getItem("unread")):null;
			if (!unreads) {
				localStorage.setItem("unread", JSON.stringify([{
					friend_id: data.data.m_from_user_id,
					unreadNumber: 1
				}]));
			} else {
				var arr = [];
				unreads.forEach(element => {
					if (element.friend_id == data.data.m_from_user_id) {
						++element.unreadNumber;
						localStorage.setItem("unread", JSON.stringify(unreads));
					}
					arr.push(element.friend_id);
				});
				if (arr.indexOf(data.data.m_from_user_id) <= -1) {
					unreads.push({
						friend_id: data.data.m_from_user_id,
						unreadNumber: 1
					});
					localStorage.setItem("unread", JSON.stringify(unreads));
				}
			}
		} else if (data.tag == "group"){
			// ��¼Ⱥ��δ����Ϣ��
			var groupunreads = localStorage.getItem("groupUnread")?JSON.parse(localStorage.getItem("groupUnread")):null;
			if (!groupunreads) {
				groupunread.push(read);
				localStorage.setItem("groupUnread", JSON.stringify([{
					group_id: data.ug_id,
					unreadNumber: 1
				}]));
			} else {
				var array = [];
				groupunreads.forEach(element => {
					if (element.group_id == data.ug_id) {
						++element.unreadNumber;
						localStorage.setItem("groupUnread",JSON.stringify(groupunreads));
					}
					array.push(element.group_id);
				});
				if (array.indexOf(data.ug_id) <= -1) {
					groupunreads.push({
						group_id: data.ug_id,
						unreadNumber: 1
					});
					localStorage.setItem("groupUnread",JSON.stringify(groupunreads));
				}
			}
		}
	},
	staticsShareUnread(){// δ�����޺����ۻ���
		var num = 0;
		var number = 0;
		var arr = localStorage.getItem("unreadlike")?JSON.parse(localStorage.getItem("unreadlike")):null;// δ������
		if (arr) {
			arr.forEach((element) => {
				num += element.unreadNumber;
			});
		}
		var array = localStorage.getItem("unreadcomment")?JSON.parse(localStorage.getItem("unreadcomment")):null;// δ������
		if (array) {
			array.forEach((element) => {
				number += element.unreadNumber;
			});
		}
		localStorage.setItem("circlecountUnread", num + number);
		return num + number;
	},
	recordUnreadShareComment(data){// ��¼����δ����
		var unreadcomments = localStorage.getItem("unreadcomment")?JSON.parse(localStorage.getItem("unreadcomment")):null;
		if (!unreadcomments) {
			localStorage.setItem("unreadcomment", JSON.stringify([{
				commentId: data.comment.u_id,
				unreadNumber: 1
			}]));
		} else {
			var array = [];
			unreadcomments.forEach(element => {
				if (element.commentId== data.comment.u_id) {
					++element.unreadNumber;
					localStorage.setItem("unreadcomment", JSON.stringify(unreadcomments));
				}
				array.push(element.commentId);
			});
			if (array.indexOf(data.comment.u_id) <= -1) {
				var r = {
					commentId: data.comment.u_id,
					unreadNumber: 1
				};
				unreadcomments.push(r);
				localStorage.setItem("unreadcomment", JSON.stringify(unreadcomments));
			}
		}
		localStorage.setItem("newmsgList", JSON.stringify([data.comment.user]));
		//��ȡ����Ϣ�б�
		let msgshowList = localStorage.getItem("msgshowLists")?JSON.parse(localStorage.getItem("msgshowLists")):[];
		msgshowList.unshift(data);
		localStorage.setItem("msgshowLists", JSON.stringify(msgshowList));
	},
	recordUnreadShareLike(data){//��¼����δ����
		if(data.tag == 'like'){ 
			var unreadlikes = localStorage.getItem("unreadlike")?JSON.parse(localStorage.getItem("unreadlike")):null;
			if (!unreadlikes) {
				// δ�������ǿյľ�����
				localStorage.setItem("unreadlike", JSON.stringify([{
					likeId: data.userinfo.u_id,
					unreadNumber: 1
				}]));
			} else {
				// δ�����޲�Ϊ�վ��ۼ�
				var arr = [];
				unreadlikes.forEach((element) => {
					if (element.likeId == data.userinfo.u_id) {
						++element.unreadNumber;
						localStorage.setItem("unreadlike", JSON.stringify(unreadlikes));
					}
					arr.push(element.likeId);
				});
				// ������id���ڼ�¼���������ȥ
				if (arr.indexOf(data.userinfo.u_id) <= -1) {
					var r = {
						likeId: data.userinfo.u_id,
						unreadNumber: 1,
					};
					unreadlikes.push(r);
					localStorage.setItem("unreadlike", JSON.stringify(unreadlikes));
				}
			}
			localStorage.setItem("newmsgList", JSON.stringify([data.userinfo]));
			let msgshowList = localStorage.getItem("msgshowLists")?JSON.parse(localStorage.getItem("msgshowLists")):[];
			//��ȡ����Ϣ�б�
			msgshowList.unshift(data);
			localStorage.setItem("msgshowLists", JSON.stringify(msgshowList));
		} 
	},
	resetChatUnread(friend_id){
		var unread = JSON.parse(localStorage.getItem("unread"));
		var countUnread = JSON.parse(localStorage.getItem("countUnread"));
		if (unread) {
			unread.forEach((item) => {
				if (item.friend_id == friend_id && item.unreadNumber != 0) {
					countUnread = countUnread - item.unreadNumber;
					item.unreadNumber = 0;
				}
			});
			localStorage.setItem("countUnread", JSON.stringify(countUnread));
			localStorage.setItem("unread", JSON.stringify(unread));
		}
	},
	resetGroupChatUnread(id){
		var groupUnread = JSON.parse(localStorage.getItem("groupUnread"));
		var countUnread = JSON.parse(localStorage.getItem("countUnread"));
		if (groupUnread) {
			groupUnread.forEach((item) => {
				if (item.group_id == id && item.unreadNumber != 0) {
					countUnread = countUnread - item.unreadNumber;
					item.unreadNumber = 0;
				}
			});
			localStorage.setItem("countUnread", JSON.stringify(countUnread));
			localStorage.setItem("groupUnread", JSON.stringify(groupUnread));
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/Websocket.js